import{px as t}from"../../../value/types/numbers/units.mjs.js";function r(r,n,e){return"string"==typeof r?r:t.transform(n+e*r)}function n(t,n,e){return`${r(n,t.x,t.width)} ${r(e,t.y,t.height)}`}export{n as calcSVGTransformOrigin};
